export function useFlashcardOperations(setFlashcards, setGroups) {
  const addFlashcard = (question, answer, groupId = null, incorrect = null) => {
    const newCard = {
      id: Date.now(),
      question,
      answer,
      incorrect,
      groupId,
      createdAt: new Date().toISOString(),
      reviewed: false,
      lastReviewed: null,
      correctCount: 0,
      incorrectCount: 0,
      lastAnsweredCorrect: null
    };
    setFlashcards(prev => [...prev, newCard]);
    return newCard;
  };

  const markCardAsReviewed = (id, wasCorrect = null) => {
    setFlashcards(prev => {
      return prev.map(card =>
        card.id === id ? {
          ...card,
          reviewed: true,
          lastReviewed: new Date().toISOString(),
          correctCount: wasCorrect === true ? (card.correctCount || 0) + 1 : (card.correctCount || 0),
          incorrectCount: wasCorrect === false ? (card.incorrectCount || 0) + 1 : (card.incorrectCount || 0),
          lastAnsweredCorrect: wasCorrect ?? card.lastAnsweredCorrect
        } : card
      );
    });
  };

  const deleteFlashcard = (id) => {
    setFlashcards(prev => {
      const card = prev.find(c => c.id === id);
      if (card && card.groupId) {
        setGroups(prevGroups =>
          prevGroups.map(group =>
            group.id === card.groupId
              ? { ...group, cardIds: group.cardIds.filter(cardId => cardId !== id) }
              : group
          )
        );
      }
      return prev.filter(card => card.id !== id);
    });
  };

  const updateFlashcard = (id, updates) => {
    setFlashcards(prev =>
      prev.map(card =>
        card.id === id
          ? {
              ...card,
              question: updates.question ?? card.question,
              answer: updates.answer ?? card.answer,
              incorrect: updates.incorrect ?? card.incorrect,
            }
          : card
      )
    );
  };

  const addFlashcardsToGroup = (cards, groupId) => {
    const newCards = cards.map(card => ({
      id: Date.now() + Math.random(),
      question: card.question,
      answer: card.answer,
      incorrect: card.incorrect,
      groupId,
      createdAt: new Date().toISOString()
    }));

    setFlashcards(prev => [...prev, ...newCards]);
    setGroups(prev =>
      prev.map(group =>
        group.id === groupId
          ? { ...group, cardIds: [...group.cardIds, ...newCards.map(card => card.id)] }
          : group
      )
    );

    return newCards;
  };

  return {
    addFlashcard,
    deleteFlashcard,
    updateFlashcard,
    markCardAsReviewed,
    addFlashcardsToGroup
  };
}
